import { RelativeTimeSpan } from 'dashboard/models/analytics-query-template';

export const CUSTOM_INTERVAL_MIN = 1;
export const CUSTOM_INTERVAL_MAX = 365;

export enum IntervalOptionsValues {
  Last7Days = '7_days',
  Last14Days = '14_days',
  Last30Days = '30_days',
  ThisMonth = 'this_month',
  LastMonth = 'last_month',
  Custom = 'custom',
}

export const INTERVAL_OPTIONS = [
  {
    label: 'Last 7 days',
    value: IntervalOptionsValues.Last7Days,
  },
  {
    label: 'Last 14 days',
    value: IntervalOptionsValues.Last14Days,
  },
  {
    label: 'Last 30 days',
    value: IntervalOptionsValues.Last30Days,
  },
  {
    label: 'This month',
    value: IntervalOptionsValues.ThisMonth,
  },
  {
    label: 'Last month',
    value: IntervalOptionsValues.LastMonth,
  },
  {
    label: 'Custom',
    value: IntervalOptionsValues.Custom,
  },
];

export type StandardQueryTemplateIntervalOptions = Exclude<
  IntervalOptionsValues,
  IntervalOptionsValues.Custom
>;

export const INTERVAL_OPTIONS_TO_DATE_RANGE: Record<
  StandardQueryTemplateIntervalOptions,
  RelativeTimeSpan
> = {
  [IntervalOptionsValues.Last7Days]: {
    interval: 7,
    unit: 'days',
  },
  [IntervalOptionsValues.Last14Days]: {
    interval: 14,
    unit: 'days',
  },
  [IntervalOptionsValues.Last30Days]: {
    interval: 30,
    unit: 'days',
  },
  [IntervalOptionsValues.ThisMonth]: {
    interval: 1,
    unit: 'months',
  },
  [IntervalOptionsValues.LastMonth]: {
    interval: 2,
    unit: 'months',
  },
};
